import { render } from "./SectionWrapperNew.vue?vue&type=template&id=2ad76e36&scoped=true"
import script from "./SectionWrapperNew.vue?vue&type=script&lang=js"
export * from "./SectionWrapperNew.vue?vue&type=script&lang=js"

import "./SectionWrapperNew.vue?vue&type=style&index=0&id=2ad76e36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad76e36"]])

export default __exports__